import Vue from 'vue'
import { Button, Tabbar, TabbarItem, Icon } from 'vant'

Vue.use(Button)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Icon)